import React, { createContext, useMemo, useState } from "react";
import { OpenClubs } from "../types";

interface OpenClubsContextData {
  openClubs: OpenClubs[];
  setPromoterGroupOpenClubs: (openClubs: OpenClubs[]) => void;
}

export const OpenClubsContext = createContext<OpenClubsContextData>({
  openClubs: [],
  setPromoterGroupOpenClubs: () => {},
});

export const OpenClubsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [openClubs, setPromoterGroupOpenClubs] = useState<OpenClubs[]>([]);
  const value = useMemo(() => ({ openClubs, setPromoterGroupOpenClubs }), [openClubs]);
  return (
    <OpenClubsContext.Provider value={value}>
      {children}
    </OpenClubsContext.Provider>
  );
};
